// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { Bell, BellOff, BellRing } from 'lucide-react';
import { Button } from './ui/button';
import { useNotifications } from '../hooks/useNotifications';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

export function NotificationButton() {
  const { permission, loading, supported, requestPermission, isEnabled } = useNotifications();

  if (!supported) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="ghost" size="icon" disabled className="text-slate-400">
              <BellOff className="w-5 h-5" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Notificações não suportadas neste navegador</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  if (isEnabled) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="ghost" size="icon" className="text-green-600">
              <BellRing className="w-5 h-5" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Notificações ativadas</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button 
            variant="ghost" 
            size="icon"
            onClick={requestPermission}
            disabled={loading}
            className={permission === 'denied' ? 'text-red-500' : 'text-slate-600'}
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin" />
            ) : (
              <Bell className="w-5 h-5" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{permission === 'denied' ? 'Notificações bloqueadas' : 'Ativar notificações'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
